import styled from 'styled-components';
import { theme } from 'styled';
import { EmptyButton, getTheme, parseProp, parseTheme } from 'mol-ui';

const _getStatusColor = status => {
    const {
        secondaryColor,
        statusAvailable,
        statusBussy,
        statusUnavailable
    } = theme;
    switch (status) {
    case 'Disponible':
    case 'Esperando llamada':
        return statusAvailable;
    case 'En Sesión':
        return statusBussy;
    case 'No Disponible':
        return statusUnavailable;
    default:
        return secondaryColor;
    }
};

export const Actions = styled.div`
    i {
        margin-left: 15px;
    }
`;

export const Avatar = styled.img`
    border-radius: 100%;
    height: 65px;
    object-fit: cover;
    width: 65px;
`;

export const Container = styled(EmptyButton)`
    border-bottom: 1px solid ${ getTheme('disabledColor') };
    display: flex;
    justify-content: space-between;
    padding: 15px 0px;
    width: 100%;
`;

export const Icon = styled.div`
    ${ parseProp('color', 'background') }
    border-radius: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    margin-right: 25px;
    min-height: 65px;
    min-width: 65px;
`;

export const Info = styled.div`
    align-items: center;
    display: flex;
`;

export const Status = styled.p`
    color: ${ ({ status }) => _getStatusColor(status) };
    font-size: .8rem;
    margin: 0;

    &:before {
        content: "● ";
    }
`;
